import {useState, useEffect, useRef} from 'react'
import { useAuthApp } from '../../app/auth';
import '../../../css/header.css';
import { Link, useNavigate } from 'react-router-dom';
import UserData from '../plugins/UserData';
import { useTranslation } from "react-i18next";


function WinefactsHeader() {
    const { t, i18n } = useTranslation();
    const isLoggedIn = useAuthApp((state) => state.isLoggedIn);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navMenuRef = useRef(null);
    const navUlsRef = useRef([]);
    const menuIconRef = useRef([]);
    const menuContentRef = useRef(null);
    const bodyRef = useRef(document.body); // Ref for the body element

    const handleHamburgerClick = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang); // Change the language
        localStorage.setItem('language', lang);
    };

    useEffect(() => {
        // Toggle body scroll lock
        if (bodyRef.current) {
        if (isMenuOpen) {
            bodyRef.current.classList.add('no-scroll');
        } else {
            bodyRef.current.classList.remove('no-scroll');
        }
        }
    }, [isMenuOpen]);

    useEffect(() => {
        // This effect handles the active class on nav ULs
        if (navUlsRef.current) {
        if (isMenuOpen) {
            navUlsRef.current.forEach(navUl => navUl.classList.add('active'));
        } else {
            setTimeout(() => {
            navUlsRef.current.forEach(navUl => navUl.classList.remove('active'));
            }, 400);
        }
        }
    }, [isMenuOpen]);

    const handleNavLinkClick = () => {
        setTimeout(() => {
        setIsMenuOpen(false);
        }, 250);
    };

  return (
    <>
            <header>
                <nav className="navbar">
                    <div ref={navMenuRef} className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                        <div ref={menuContentRef} className={`menu-content ${isMenuOpen ? 'active' : ''}`}>
                            <ul ref={el => el && navUlsRef.current.push(el)}> {/* Check if el exists */}
                                {isLoggedIn && (
                                    <>
                                        <li className="">
                                            <Link className="" to="/dashboard" onClick={handleNavLinkClick}>
                                                {t("dashboard")}
                                            </Link>
                                        </li>
                                        <li className="">
                                            <Link className="" to="/product-names" onClick={handleNavLinkClick}>
                                                {t("productNames")}
                                            </Link>
                                        </li>
                                        <li className="">
                                            <Link className="" to="/create-product" onClick={handleNavLinkClick}>
                                                {t("newProduct")}
                                            </Link>
                                        </li>
                                        <li className="">
                                            <Link className="" to="/user-profile" onClick={handleNavLinkClick}>
                                                {t("profile")}
                                            </Link>
                                        </li>
                                    </>
                                )}
                            </ul>
                            <ul ref={el => el && navUlsRef.current.push(el)}> {/* For collection of ul elements and manipulating e.g. class active */}
                                <li className="">
                                    <Link className="" to="/spendings" onClick={handleNavLinkClick}>
                                        {t("contribution")}
                                    </Link>
                                </li>
                                <li className="">
                                    <Link className="" to="/register" onClick={handleNavLinkClick}>
                                        {t("registration")}
                                    </Link>
                                </li>
                                {isLoggedIn ? (
                                    <li className="">
                                        <Link className="" to="/logout" onClick={handleNavLinkClick}>
                                            {t("logout")}
                                        </Link>
                                    </li>
                                ) : (
                                    <li className="">
                                        <Link className="" to="/login" onClick={handleNavLinkClick}>
                                            {t("login")}
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <button
                        className={`menu-button ${isMenuOpen ? 'active' : ''}`}
                        onClick={handleHamburgerClick}
                        title="Open Nav Menu"
                    >
                        <div className="menu-icon"></div>
                    </button>
                    <div className="language-switcher resp">
                        <a onClick={() => handleLanguageChange('en')} className="lang-btn">
                            EN
                        </a>
                        <span className="seperator">|</span>
                        <a onClick={() => handleLanguageChange('de')} className="lang-btn">
                            DE
                        </a>
                    </div>
                </nav>
            </header>
        </>
  )
}

export default WinefactsHeader